const DONORS = [
  { name: "R. Bruce", amount: 500 },
  { name: "P. Martin", amount: 200 },
];

export const Donors = () => {
  return (
    <section
      id="donors"
      className="scroll-mt-36 border-t border-[#DCDCD6] bg-[#EBEBE6] px-6 py-24 md:scroll-mt-24 md:py-32"
      data-testid="donors-section"
    >
      <div className="mx-auto max-w-3xl text-center">
        <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#666666]">
          With Gratitude
        </p>
        <h2 className="mt-4 font-serif text-3xl font-light leading-tight tracking-tight md:text-5xl">
          Campaign Donations
        </h2>
        <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-[#666666]">
          This campaign is powered by neighbours. Thank you to everyone who
          has contributed.
        </p>
        <div className="mx-auto mt-12 max-w-md">
          {DONORS.map((donor, i) => (
            <div
              key={donor.name}
              className="flex items-baseline justify-between border-b border-[#DCDCD6] py-5"
              data-testid={`donor-${i + 1}`}
            >
              <span className="font-serif text-2xl font-light tracking-tight">{donor.name}</span>
              <span className="text-sm font-semibold tracking-[0.1em] text-[#666666]">
                ${donor.amount.toLocaleString()}
              </span>
            </div>
          ))}
        </div>
        <p className="mt-10 text-[10px] font-bold uppercase tracking-[0.25em] text-[#999999]">
          Contributions from eligible Ontario residents only · Municipal
          election rules apply
        </p>
      </div>
    </section>
  );
};
